import { render, staticRenderFns } from "./im-history-record.vue?vue&type=template&id=262493a4"
import script from "./im-history-record.vue?vue&type=script&lang=js"
export * from "./im-history-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262493a4')) {
      api.createRecord('262493a4', component.options)
    } else {
      api.reload('262493a4', component.options)
    }
    module.hot.accept("./im-history-record.vue?vue&type=template&id=262493a4", function () {
      api.rerender('262493a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-history-record.vue"
export default component.exports